/* BonheurReBorn — Theme JS */

/* Product card swipe (debounced MutationObserver) */
(function() {
  function initSwipe() {
    document.querySelectorAll('[data-swipe]:not([data-swipe-init])').forEach(function(card) {
      card.setAttribute('data-swipe-init', '');
      var track = card.querySelector('.product-card__swipe-track');
      var dots = card.querySelectorAll('.product-card__dot');
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function() {
        var w = track.offsetWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        dots.forEach(function(d, j) { d.classList.toggle('active', j === i); });
      }, { passive: true });
    });
  }
  document.addEventListener('DOMContentLoaded', initSwipe);
  var debounceTimer;
  if (document.querySelector('[data-swipe]')) {
    new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initSwipe, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Mobile menu toggle */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    if (!menu || !toggles.length) return;

    /* KÖK KURAL: body ASLA kilitlenmez (position:fixed / overflow:hidden / class-toggle YOK).
       Kilit yoksa kilitli kalma da yok. Scroll hapsi tamamen CSS'te:
       .mobile-menu__overlay → touch-action:none + overscroll-behavior:contain
       .mobile-menu__inner   → overscroll-behavior:contain  (bkz. base.css) */
    function open() {
      menu.classList.add('is-open'); if (overlay) overlay.classList.add('is-visible');
    }
    function close() {
      menu.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-visible');
    }

    /* Eski sürüm artığı temizliği: cache'teki eski JS body'yi kilitli bırakmış olabilir. */
    if (document.body.style.position === 'fixed') {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    }

    toggles.forEach(function(btn) { btn.addEventListener('click', function() { menu.classList.contains('is-open') ? close() : open(); }); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  });
})();

/* Announcement bar yüksekliği → CSS variable (header top offset + body padding) */
(function() {
  function setAnnouncementHeight() {
    var bar = document.querySelector('[data-announcement-bar]');
    var h = (bar && bar.offsetHeight) ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setAnnouncementHeight();
  var bar = document.querySelector('[data-announcement-bar]');
  if (bar && window.ResizeObserver) {
    new ResizeObserver(setAnnouncementHeight).observe(bar);
  }
  window.addEventListener('resize', setAnnouncementHeight, { passive: true });
})();

/* Sticky header scroll shadow */
(function() {
  function initHeaderScrollState() {
    var header = document.querySelector('[data-header]');
    if (!header || header.getAttribute('data-scroll-state-init') === 'true') return;
    header.setAttribute('data-scroll-state-init', 'true');

    var scrolled = null;
    function updateHeaderState() {
      var s = window.scrollY > 10;
      if (s !== scrolled) {
        scrolled = s;
        header.classList.toggle('header--scrolled', scrolled);
      }
    }

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
    window.addEventListener('resize', updateHeaderState, { passive: true });
    window.addEventListener('pageshow', updateHeaderState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScrollState);
  } else {
    initHeaderScrollState();
  }
})();

/* Header scroll fallback for browsers that miss deferred init on cached navigations */
(function() {
  function updateHeaderState() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var s = window.scrollY > 10;
    header.classList.toggle('header--scrolled', s);
  }
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
})();

/* Cart item quantity (delegated) */
(function() {
  function clampQty(value) {
    var qty = parseInt(value, 10);
    if (Number.isNaN(qty) || qty < 1) return 1;
    return Math.min(qty, 99);
  }

  function setRowLoading(row, loading) {
    if (!row) return;
    row.classList.toggle('is-updating', loading);
    row.querySelectorAll('button, input').forEach(function(control) {
      control.disabled = loading;
    });
  }

  function updateCartQty(row, targetQty) {
    if (!row) return;
    targetQty = clampQty(targetQty);

    var variantId = row.getAttribute('data-variant-id');
    var allKeys = (row.getAttribute('data-all-keys') || row.getAttribute('data-item-key') || '')
      .split(',')
      .filter(Boolean);

    if (!variantId || !allKeys.length) return;

    setRowLoading(row, true);

    var R = (window.routes || {});
    var cartJsUrl = (R.cart_url || '/cart') + '.js';
    var cartUpdateUrl = (R.cart_update_url || '/cart/update') + '.js';

    fetch(cartJsUrl)
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};
        var currentParentQty = 0;

        cart.items.forEach(function(item) {
          if (String(item.variant_id) === String(variantId) && !(item.properties && item.properties._gift === 'true')) {
            currentParentQty += parseInt(item.quantity, 10) || 0;
          }
        });

        allKeys.forEach(function(key, index) {
          updates[key] = index === 0 ? targetQty : 0;
        });

        cart.items.forEach(function(item) {
          if (!item.properties || item.properties._gift !== 'true') return;
          if (String(item.properties._parent_variant) !== String(variantId)) return;

          var ratio = currentParentQty > 0 ? item.quantity / currentParentQty : 1;
          updates[item.key] = Math.max(1, Math.round(ratio * targetQty));
        });

        return fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function() { window.location.reload(); })
      .catch(function() {
        setRowLoading(row, false);
      });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-qty-btn]');
    if (!btn) return;

    e.preventDefault();
    var row = btn.closest('.cart-item');
    var input = row ? row.querySelector('[data-cart-qty-input]') : null;
    if (!input) return;

    var nextQty = clampQty(input.value) + (parseInt(btn.getAttribute('data-delta'), 10) || 0);
    nextQty = clampQty(nextQty);
    if (nextQty === clampQty(input.value)) return;

    input.value = nextQty;
    updateCartQty(row, nextQty);
  });

  document.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;

    var row = input.closest('.cart-item');
    var nextQty = clampQty(input.value);
    input.value = nextQty;
    updateCartQty(row, nextQty);
  });
})();

/* Cart item remove (delegated) */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    e.preventDefault();
    btn.style.opacity = '0.3';
    btn.style.pointerEvents = 'none';
    var row = btn.closest('.cart-item');
    if (row) row.style.opacity = '0.4';

    var cartItem = btn.closest('.cart-item');
    var updates = {};

    var allKeys = cartItem ? cartItem.getAttribute('data-all-keys') : null;
    if (allKeys) {
      allKeys.split(',').forEach(function(k) { if (k) updates[k] = 0; });
    } else {
      updates[btn.getAttribute('data-remove-key')] = 0;
    }

    var giftKey = cartItem ? cartItem.getAttribute('data-gift-key') : null;
    if (giftKey) updates[giftKey] = 0;

    var variantId = cartItem ? cartItem.getAttribute('data-variant-id') : null;

    var R = (window.routes || {});
    var cartJsUrl = (R.cart_url || '/cart') + '.js';
    var cartUpdateUrl = (R.cart_update_url || '/cart/update') + '.js';

    fetch(cartJsUrl).then(function(r) { return r.json(); }).then(function(cart) {
      cart.items.forEach(function(ci) {
        if (ci.properties && ci.properties._gift === 'true' && ci.properties._parent_variant === variantId) {
          updates[ci.key] = 0;
        }
      });
      return fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).then(function() { window.location.reload(); });
  });
})();

/* Clear cart */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-clear-cart]');
    if (!btn) return;
    btn.style.opacity = '0.3';
    var R = (window.routes || {});
    var cartClearUrl = (R.cart_url || '/cart') + '/clear.js';
    fetch(cartClearUrl, { method: 'POST' }).then(function() { window.location.reload(); });
  });
})();

/* Shared cart data — fetch once, share across scripts */
(function() {
  var _promise = null;
  window.__getCart = function() {
    if (!_promise) {
      var R = (window.routes || {});
      var cartJsUrl = (R.cart_url || '/cart') + '.js';
      _promise = fetch(cartJsUrl).then(function(r) { return r.json(); });
    }
    return _promise;
  };
})();

/* Normalize Judge.me injected all-reviews link to the real Muyu reviews page. */
(function() {
  function normalizeJudgeMeLinks(root) {
    (root || document).querySelectorAll('a.jdgm-revs-tab__url[href="/pages/reviews"]').forEach(function(link) {
      link.setAttribute('href', '/pages/musteri-yorumlari');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    normalizeJudgeMeLinks(document);
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) normalizeJudgeMeLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
